<div class="page-container account-review-detail-container container pt-2">
  <h1 class="header col-12 mb-1"> Account Details </h1>
  @if (!loading) {
    <div class="actions-container mb-3">
      <button
        type="button"
        mat-button
        color="primary"
        (click)="nav('account-review')"
      >
        <mat-icon>arrow_back_ios</mat-icon> Back to Account Monitor
      </button>
    </div>

    <div class="trade-info-container info-card mb-4 w-100 p-0">
      <div class="card-header">
        <span class="card-title-container">
          <mat-icon
            class="scoreclass-icon me-2 {{ accountDetail.ScoreClass }}"
            [matTooltip]="'Account Score: ' + accountDetail.ScoreClass"
          >
            {{ scoreClassKey[accountDetail.ScoreClass] }}
          </mat-icon>
          Account #:
          <span class="card-title mb-0 ms-2">
            {{ accountDetail.AccountNumDisplay }}
            @if (accountDetail.EncryptedAccountID) {
              <button
                type="button"
                class="decrypt-button"
                mat-icon-button
                matTooltip="Click to see raw value"
                [matTooltipShowDelay]="500"
                (click)="
                  decryptValue(accountDetail.EncryptedAccountID, 'Account #')
                "
              >
                <mat-icon>lock_open</mat-icon>
              </button>
            }
          </span>
        </span>

        @if (!rights.includes('PostTradeReadOnly')) {
          <span>
            <app-approval-menu
              [recordStatus]="accountDetail.ReviewStatus"
              [recordType]="'account'"
              (toggleStatus)="toggleReviewed($event)"
            />
          </span>
        }
      </div>
      <div class="card-info row">
        @for (accountInfo of accountInfoKey; track accountInfo.label) {
          @if (
            (accountDetail && accountDetail[accountInfo.varName]) ||
            (accountInfo.key &&
              accountInfo.key[accountDetail[accountInfo.varName]])
          ) {
            <app-card-infopoint
              class="col-sm-3 col-12"
              [datapoint]="accountInfo"
              [dataset]="accountDetail"
            />
          } @else if (
            accountInfo.varSet &&
            accountDetail.Details[accountInfo.varSet] &&
            accountDetail.Details[accountInfo.varSet][accountInfo.varName]
          ) {
            <app-card-infopoint
              class="col-sm-3 col-12"
              [datapoint]="accountInfo"
              [dataset]="accountDetail.Details"
            />
          }
        }
      </div>
    </div>

    @if (rights.includes('CM') && aiSummary.length > 0) {
      <div class="info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> AI Transaction Summary </span>
        </div>
        <div class="card-info row">
          <div class="notes-list px-3" [innerHTML]="aiSummary"></div>
          <div class="ai-disclaimer px-3 pt-3 w-100">
            <span>
              **This is created by generative AI. Results and details should be
              verified.
            </span>
          </div>
        </div>
      </div>
    }

    @if (accountDetail?.Details?.bridges) {
      <div class="alerts-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Alerts </span>
        </div>
        <div class="card-info row">
          <div class="alerts w-100">
            @for (bridge of accountDetail.Details.bridges; track bridge) {
              @if (ptSvc.bridgeHasAlerts(bridge.trueRules)) {
                <app-reason-text
                  class="col-12"
                  [data]="bridge.trueRules"
                  [defaultView]="'list'"
                />
              } @else {
                <div class="no-data no-alerts w-100">No Alerts Found</div>
              }
            }
          </div>
        </div>
      </div>
    }

    @if (accountDetail.Details && accountDetail.Details.Account) {
      <div class="multi-table-container">
        <app-multi-table-card
          class="{{
            accountDetail.Details && accountDetail.Details.Account
              ? 'w-50'
              : 'w-100'
          }}"
          [title]="'Account Info'"
          [infoKey]="accountKey"
          [tradeDetail]="accountDetail"
        />

        <app-multi-table-card
          class="{{
            accountDetail.Details && accountDetail.Details.Account
              ? 'w-50'
              : 'w-100'
          }}"
          [title]="'Client Suitability Info'"
          [infoKey]="suitabilityKey"
          [tradeDetail]="accountDetail"
        />
      </div>
    }

    <div class="info-card mb-4">
      <div class="card-header">
        <span class="card-title mb-0">Actions</span>
        @if (!rights.includes('PostTradeReadOnly')) {
          <span>
            <app-approval-menu
              [recordStatus]="accountDetail.ReviewStatus"
              [recordType]="'account'"
              (toggleStatus)="toggleReviewed($event)"
            />
          </span>
        }
      </div>
      <div class="actions-card">
        <div class="custom-tabs">
          <mat-tab-group [selectedIndex]="selectedActionTab">
            <mat-tab label="Notes & Attachments">
              <app-attachments-widget
                [tradeId]="accountId"
                [tradeDetail]="accountDetail"
                [widgetType]="'account'"
                [readOnly]="rights.includes('PostTradeReadOnly')"
              />
            </mat-tab>

            <mat-tab label="Account Review Status History">
              <app-expanding-table
                [dataset]="accountDetail?.AccountApprovalHistory"
                [evalKey]="accountReviewKey"
              />
            </mat-tab>

            @if (rights.includes('CM')) {
              <mat-tab label="Case History">
                @if (!rights.includes('PostTradeReadOnly')) {
                  <div class="mb-2 pt-2 initiate-case-container">
                    <button
                      type="button"
                      mat-raised-button
                      color="primary"
                      class="w-50"
                      [disabled]="!accountDetail.RepCode"
                      (click)="initiateCase()"
                    >
                      <mat-icon>medical_services</mat-icon> Initiate Case
                    </button>
                  </div>
                }

                <app-expanding-table
                  [dataset]="caseHistory"
                  [evalKey]="caseHistoryKey"
                  [actionColumn]="{
                    link: 'case-management/case-manager/',
                    selector: 'CRID',
                    tooltip: 'Review Case',
                    icon: 'rate_review',
                    external: true,
                  }"
                />
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      </div>
    </div>

    @if (
      accountDetail.Details && accountDetail.Details.DisplayFX.ShowTradeHistory
    ) {
      <div class="mutual-funds-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Transaction History </span>
        </div>
        <app-expanding-table
          [dataset]="accountDetail.Details.TradeHistory"
          [evalKey]="transactionHistoryKey"
          [actionColumn]="{
            link: 'trade-review/',
            selector: 'TradeID',
            tooltip: 'View Trade',
            icon: 'launch',
            external: true,
          }"
        />
      </div>
    }

    @if (
      accountDetail.AccountHistory && accountDetail.AccountHistory.length > 0
    ) {
      <div class="mutual-funds-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Account Review History </span>
        </div>
        <app-expanding-table
          [dataset]="accountDetail.Details.AccountHistory"
          [evalKey]="accountHistoryKey"
          [actionColumn]="{
            link: 'account-review/',
            selector: 'AccountID_Rev',
            tooltip: 'View Account',
            icon: 'launch',
            external: true,
          }"
        />
      </div>
    }

    <app-holdings-card [chartDetails]="accountDetail.Details" />

    @if (accountDetail?.AccountProfile?.RecentAccountActivity) {
      <div class="mutual-funds-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Recent Account Activity </span>
        </div>
        <app-expanding-table
          [dataset]="accountDetail.AccountProfile.RecentAccountActivity"
          [evalKey]="recentActivityKey"
          [actionColumn]="
            rights.includes('TradeReview')
              ? {
                  link: 'trade-review/',
                  selector: 'TradeID',
                  tooltip: 'View Transaction',
                  icon: 'launch',
                  external: false,
                }
              : null
          "
        />
      </div>
    }

    @if (
      accountDetail.Details && accountDetail.Details.DisplayFX.ShowPreTrade
    ) {
      <div class="mutual-funds-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> RightBRIDGE Pre-Trade Cases </span>
        </div>
        <div class="actions-card">
          <div class="custom-tabs">
            <mat-accordion>
              @for (
                case of accountDetail.Details.PreTradeMainDisplay;
                track case.CaseNumber;
                let i = $index
              ) {
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      {{ case.Name }}
                    </mat-panel-title>
                    <mat-panel-description>
                      (RBCaseID{{ case.CaseNumber }}) -
                      {{ case.SubmitDate }}
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <div class="pretrade-row row">
                    @for (infoPoint of preTradeAccordionKey; track infoPoint) {
                      @if (
                        accountDetail.Details.PreTradeMainDisplay[i][infoPoint]
                      ) {
                        <app-card-infopoint
                          class="col-sm-3 col-12"
                          [datapoint]="infoPoint"
                          [dataset]="
                            accountDetail.Details.PreTradeMainDisplay[i]
                          "
                        />
                      }
                    }
                  </div>

                  <div class="row mt-2">
                    @if (
                      accountDetail.Details.PreTradeMainDisplay[i]['PPStatus']
                    ) {
                      <div class="col-12 mb-2">
                        <div class="app-product-container">
                          <div class="product-header">
                            <mat-icon class="me-1" svgIcon="pp_icon" />
                            <strong> Product Profiler </strong>
                          </div>

                          <div class="row product-labels-container">
                            <div class="col-sm-6 col-12">
                              <div class="pp-selected-product-label p-2">
                                Selected Products
                              </div>
                            </div>
                            <div class="col-sm-6 col-12">
                              <div class="pp-selected-product-label p-2">
                                Source of Funds
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-sm-6 col-12 product-list">
                              <div class="row p-2">
                                @for (
                                  product of accountDetail.Details[
                                    'ProductSelectedPP'
                                  ];
                                  track product.ProfileID
                                ) {
                                  @if (
                                    product.ProfileID === case.UniqueProfiles &&
                                    product.Type === 'product'
                                  ) {
                                    <div class="col-sm-6 col-12 mb-2">
                                      <div class="product-container">
                                        <span
                                          class="selected-product-container"
                                        >
                                          <div
                                            class="selected-product-description"
                                          >
                                            @switch (product.ScoreClass) {
                                              @case ('positive') {
                                                <span
                                                  class="status positive me-2"
                                                >
                                                  <mat-icon
                                                    >check_circle</mat-icon
                                                  >
                                                </span>
                                              }
                                              @case ('neutral') {
                                                <span
                                                  class="status neutral me-2"
                                                >
                                                  <mat-icon>error</mat-icon>
                                                </span>
                                              }
                                              @case ('negative') {
                                                <span
                                                  class="status negative me-2"
                                                >
                                                  <mat-icon>cancel</mat-icon>
                                                </span>
                                              }
                                            }
                                            <span class="annuity-datapoint">
                                              <span class="annuity-name">
                                                {{ product.Name }}
                                              </span>
                                              <span class="annuity-details">
                                                Amount:
                                                {{ product.Amount }}
                                              </span>
                                            </span>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  }
                                }
                              </div>
                            </div>

                            <div class="col-sm-6 col-12">
                              <div class="row p-2">
                                @for (
                                  product of accountDetail.Details[
                                    'ProductSelectedPP'
                                  ];
                                  track product.ProfileID
                                ) {
                                  @if (
                                    product.ProfileID === case.UniqueProfiles &&
                                    product.Type === 'rollover'
                                  ) {
                                    <div class="col-sm-6 col-12 mb-2">
                                      <div class="product-container">
                                        <span
                                          class="selected-product-container"
                                        >
                                          <div
                                            class="selected-product-description"
                                          >
                                            @switch (product.ScoreClass) {
                                              @case ('positive') {
                                                <span
                                                  class="status positive me-2"
                                                >
                                                  <mat-icon
                                                    >check_circle</mat-icon
                                                  >
                                                </span>
                                              }
                                              @case ('neutral') {
                                                <span
                                                  class="status neutral me-2"
                                                >
                                                  <mat-icon>error</mat-icon>
                                                </span>
                                              }
                                              @case ('negative') {
                                                <span
                                                  class="status negative me-2"
                                                >
                                                  <mat-icon>cancel</mat-icon>
                                                </span>
                                              }
                                            }
                                            <span class="annuity-datapoint">
                                              <span class="annuity-name">
                                                {{ product.Name }}
                                              </span>
                                              <span class="annuity-details">
                                                Amount:
                                                {{ product.Amount }}
                                              </span>
                                            </span>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }

                    @if (
                      accountDetail.Details.PreTradeMainDisplay[i][
                        'AWStatus'
                      ] &&
                      (hasAppProducts(
                        'AWSelectedProduct',
                        case.UniqueProfiles
                      ) ||
                        hasAppProducts(
                          'CurrentAnnuityDetailsArray',
                          case.UniqueProfiles
                        ))
                    ) {
                      <div class="col-12 mb-2">
                        <div class="app-product-container">
                          <div class="product-header">
                            <mat-icon class="me-1" svgIcon="aw_icon" />
                            <strong> Annuity Wizard </strong>
                          </div>

                          <div class="row product-labels-container">
                            <div class="col-sm-6 col-12">
                              <div class="pp-selected-product-label p-2">
                                Selected Annuities
                              </div>
                            </div>
                            <div class="col-sm-6 col-12">
                              <div class="pp-selected-product-label p-2">
                                Exchange Sources
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-sm-6 col-12 product-list">
                              <div class="row p-2">
                                @for (
                                  product of accountDetail.Details[
                                    'AWSelectedProduct'
                                  ];
                                  track product.ProfileID
                                ) {
                                  @if (
                                    product.ProfileID === case.UniqueProfiles
                                  ) {
                                    <div
                                      class="col-sm-6 col-12 product-container"
                                    >
                                      <span class="selected-product-container">
                                        <div
                                          class="selected-product-description"
                                        >
                                          @switch (product.ScoreClass) {
                                            @case ('positive') {
                                              <span
                                                class="status positive me-2"
                                              >
                                                <mat-icon>
                                                  check_circle
                                                </mat-icon>
                                              </span>
                                            }
                                            @case ('neutral') {
                                              <span class="status neutral me-2">
                                                <mat-icon>error</mat-icon>
                                              </span>
                                            }
                                            @case ('negative') {
                                              <span
                                                class="status negative me-2"
                                              >
                                                <mat-icon>cancel</mat-icon>
                                              </span>
                                            }
                                          }
                                          <span class="annuity-datapoint">
                                            <span class="annuity-name">
                                              {{ product.ProductName }}
                                            </span>
                                            <span class="annuity-details">
                                              CUSIP: {{ product.Cusip }} |
                                              Premium: {{ product.Premium }}
                                            </span>
                                          </span>
                                        </div>
                                      </span>
                                    </div>
                                  }
                                }
                              </div>
                            </div>

                            <div class="col-sm-6 col-12 product-list">
                              <div class="row p-2">
                                @for (
                                  product of accountDetail.Details[
                                    'CurrentAnnuityDetailsArray'
                                  ];
                                  track product.ProfileID
                                ) {
                                  @if (
                                    product.ProfileID === case.UniqueProfiles
                                  ) {
                                    <div
                                      class="col-sm-6 col-12 product-container"
                                    >
                                      <span class="selected-product-container">
                                        <div
                                          class="selected-product-description"
                                        >
                                          @switch (product.ScoreClass) {
                                            @case ('positive') {
                                              <span
                                                class="status positive me-2"
                                              >
                                                <mat-icon>
                                                  check_circle
                                                </mat-icon>
                                              </span>
                                            }
                                            @case ('neutral') {
                                              <span class="status neutral me-2">
                                                <mat-icon>error</mat-icon>
                                              </span>
                                            }
                                            @case ('negative') {
                                              <span
                                                class="status negative me-2"
                                              >
                                                <mat-icon>cancel</mat-icon>
                                              </span>
                                            }
                                          }
                                          <span class="annuity-datapoint">
                                            <span class="annuity-name">
                                              {{ product.Name }}
                                            </span>
                                            <span class="annuity-details">
                                              Surrender Amount:
                                              {{ product.TotalAssets }}
                                            </span>
                                          </span>
                                        </div>
                                      </span>
                                    </div>
                                  }
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }

                    @if (
                      accountDetail.Details.PreTradeMainDisplay[i][
                        'IWStatus'
                      ] &&
                      (hasAppProducts(
                        'ProductSelectedIW',
                        case.UniqueProfiles
                      ) ||
                        hasAppProducts(
                          'SelectedFundDataOUT',
                          case.UniqueProfiles
                        ))
                    ) {
                      <div class="col-12 mb-2">
                        <div class="app-product-container">
                          <div class="product-header mb-2">
                            <mat-icon class="me-1" svgIcon="iw_icon" />
                            <strong> Investment Wizard </strong>
                          </div>

                          <div class="product-container px-2 mb-2">
                            <div class="row">
                              @for (
                                product of accountDetail.Details[
                                  'ProductSelectedIW'
                                ];
                                track product.ProfileID
                              ) {
                                @if (
                                  product.ProfileID === case.UniqueProfiles
                                ) {
                                  <div class="col-sm-4 col-12 mb-2">
                                    <span class="selected-product-container">
                                      <div class="selected-product-label">
                                        @switch (product.Type) {
                                          @case ('IWResult') {
                                            Selected Program
                                          }
                                          @case ('IWPortfolio') {
                                            Selected Portfolio
                                          }
                                        }
                                      </div>
                                      <div class="selected-product-description">
                                        @switch (product.ScoreClass) {
                                          @case ('positive') {
                                            <span class="status positive me-2">
                                              <mat-icon>check_circle</mat-icon>
                                            </span>
                                          }
                                          @case ('neutral') {
                                            <span class="status neutral me-2">
                                              <mat-icon>error</mat-icon>
                                            </span>
                                          }
                                          @case ('negative') {
                                            <span class="status negative me-2">
                                              <mat-icon>cancel</mat-icon>
                                            </span>
                                          }
                                        }
                                        <span class="annuity-datapoint">
                                          <span class="annuity-name">
                                            {{ product.Name }}
                                          </span>
                                          @if (product.Type === 'IWResult') {
                                            <span class="annuity-details">
                                              Amount: {{ product.Amount }}
                                            </span>
                                          }
                                        </span>
                                      </div>
                                    </span>
                                  </div>
                                }
                              }
                            </div>
                            <div class="row selected-funds">
                              <div class="product-labels-container mb-2">
                                <div
                                  class="pp-selected-product-label py-2 no-border"
                                >
                                  Selected Funds
                                </div>
                              </div>
                              @for (
                                product of accountDetail.Details[
                                  'SelectedFundDataOUT'
                                ];
                                track product.ProfileID
                              ) {
                                @if (
                                  product.ProfileID === case.UniqueProfiles
                                ) {
                                  <div class="col-sm-4 col-12 mb-2">
                                    <span class="selected-product-container">
                                      <div class="selected-product-description">
                                        <span class="annuity-datapoint">
                                          <span class="annuity-name">
                                            {{ product.FundID }}
                                            {{ product.Name }}
                                          </span>
                                          <span class="annuity-details">
                                            Share Class:
                                            {{ product.ShareClass }}
                                          </span>
                                        </span>
                                      </div>
                                    </span>
                                  </div>
                                }
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </mat-expansion-panel>
              }
            </mat-accordion>
          </div>
        </div>
      </div>
    }
  }

  <ngx-loading [show]="loading || softLoading" />
</div>
